<template>
  <div class="main-content">
    <avue-crud
        ref="crud"
        :data="tableList"
        :option="option"
        :table-loading="showLoading"
        :page.sync="page"
      >

      </avue-crud>
  </div>
</template>

<script>
import { upgradeDeviceList } from "@/api/upgrade/firmware";
import dayjs from "dayjs";

import Echarts from "@/components/echarts/echartsFunc";

export default {
  name: "index",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    tableList:{
      type:Array,
      default:[]
    }
  },
  components: {
    Echarts,
  },
  data() {
    return {
      searchData: {

      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        tip: false,
        column: [
          {
            label: "城市",
            prop: "city",
          },
          {
            label: "总设备数",
            prop: "deviceNum",
          },
          {
            label: "在线设备",
            prop: "onlineNum",
          },
          {
            label: "离线设备",
            prop: "offlineNum",
          },
          {
            label: "故障设备",
            prop: "faultNum",
          },
        ],
      },
    };
  },
  created() {
    console.log(this.tableList,'1111111');
  },
  methods: {
  },
};
</script>

<style scoped>
.main-content {
  width: 90%;
}
</style>
